import './index.scss'
import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = ['self', 'content', 'form', 'visibility', 'visibilityText', 'editButton', 'removeButton']
  static classes = ['editing']

  initialize() {
    this.updateVisibility()
  }

  edit(event) {
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass, this.editingClass)
  }

  delete() {
    Rails.ajax({
      type: 'delete',
      url: `/issue_details_section/${event.target.dataset.id}`
    })
  }

  cancel() {
    this.selfTarget.classList.remove(event.currentTarget.dataset.editingClass, this.editingClass)
  }

  toggleVisibility() {
    this.updateVisibility()
    Rails.ajax({
      type: 'put',
      dataType: 'script',
      url: `/issue_details_section/${this.selfTarget.dataset['issue-DetailsSectionEntityId']}`,
      data: `issue_details_section[show_on_overview]=${this.visibilityTarget.checked}`
    })
  }

  updateVisibility() {
    if (this.hasVisibilityTarget) {
      const visible = this.visibilityTarget.checked

      this.visibilityTextTarget.innerHTML = visible ? 'Visible' : 'Hidden'
      this.contentTarget.style.display = visible ? 'inline' : 'none'
      this.editButtonTarget.style.display = visible ? 'inline' : 'none'
      visible ? this.formTarget.classList.remove('gap-y-0') : this.formTarget.classList.add('gap-y-0')
    }
  }

  summaryClass(visible) {
    return (this.editButtonTarget.style.display === 'none' && !visible && !this.hasRemoveButtonTarget)
  }
}
